import React, { useState, useEffect } from "react";
import { FaArrowTurnUp } from "react-icons/fa6";

const ScrollTopButton = () => {
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    if (window.scrollY > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const calculateScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrolled = (scrollTop / windowHeight) * 100;
    setScrollPercentage(scrolled);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", calculateScroll);
    return () => {
      window.removeEventListener("scroll", calculateScroll);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
    return () => {
      window.removeEventListener("scroll", toggleVisible);
    };
  }, []);

  return (
    <>
      {visible && (
        <div
          className="scroll-top"
          onClick={scrollToTop}
          style={{
            background: `conic-gradient(#03a7a7 ${scrollPercentage}%, #e0e0e0 ${scrollPercentage}%)`,
          }}
        >
          <div className="goTo_top">
            <FaArrowTurnUp />
          </div>
        </div>
      )}
    </>
  );
};

export default ScrollTopButton;
